export const validTabs = [
  "activity",
  "issues",
  "board",
  "models",
  "team",
  "settings",
  "statistics",
] as const;

export type ProjectTab = (typeof validTabs)[number];
